import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { Form, useNotify, useEditContext } from 'react-admin';
import { RemoveCircleOutline } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom';
import { updateTerminalStatus } from '../../../services/Terminal';
import FontSize from '../../layout/FontSize';
import Color from '../../layout/color/Color';



const closeButton = {
  bgcolor: Color.Close,
  borderRadius: '30px',
  border: "1px solid #ccc",
  color: Color.Button,
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};
export default function TerminalCloseButton() {
  const { record } = useEditContext();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const notify = useNotify();
  const navigate = useNavigate();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSubmit = async () => {
    try {
      setIsLoading(true);

      await updateTerminalStatus(record.id, 3, password);
      notify(`Terminal closed.`, { type: 'success' });

      setIsLoading(false);
      setOpen(false);
      navigate('/Terminal');
    } catch (error) {
      notify(`Incorrect password!`, { type: 'error' });
      setIsLoading(false);
    }
  };

  if (!record || record.id == null) {
    return null;
  }

  return (
    <>
      <Button
        size="large"
        onClick={handleOpen}
        startIcon={<RemoveCircleOutline />}
        color="error"
        sx={closeButton}      >
        Close
      </Button>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle align="center" variant="h5" fontWeight="bold">
          Close terminal?
        </DialogTitle>
        <Form onSubmit={handleSubmit}>
          <Box pl="3rem" pr="3rem">
            <FormControl>
              <Typography variant="h6" align="center">
                Are you sure to close this terminal?
              </Typography>
              <Typography variant="body1" align="center">
                Please enter password to confirm.
              </Typography>
              <TextField
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                label="Password"
                variant="outlined"
                placeholder="Password"
                fullWidth
                type="password"
                required
                sx={{ mt: '15px' }}
              />
              <br />
            </FormControl>
          </Box>
          <DialogActions>
            <Button
              onClick={handleClose}
              variant="contained"
              color="inherit"
              disabled={isLoading}
            >
              Cancel
            </Button>
            <LoadingButton
              autoFocus
              color="error"
              variant="contained"
              loading={isLoading}
              type="submit"
            >
              Confirm
            </LoadingButton>
          </DialogActions>
        </Form>
      </Dialog>
    </>
  );
}
